export default "__VITE_ASSET__CPGNx54V__"